module.exports = __webpack_public_path__ + "static/img/gbz.17195e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/gbz.jpg
// module id = hDIi
// module chunks = 0